import template from './stop_performance.html';
import controller from './stop_performance.controller';
import './stop_performance.scss';

let branchManagementStopPerformanceComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
}

export default branchManagementStopPerformanceComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/stop_performance/stop_performance.component.js